import React from 'react';
import { Checkbox } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { fullWidth, moduleStyle } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const FullWidthBackground = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper>
        <Field name={[moduleStyle, fullWidth]} valuePropName={'checked'}>
          <Checkbox disabled={disabled}>
            {getI18n('general.fullwidthbackground')}
          </Checkbox>
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default FullWidthBackground;
